/**
 * controls the dropdown menu element
 */

import $ from 'jquery';

export default class Dropdown {

	constructor(options) {
		this.id = options.id;
		this.name = options.id;
		this.dropdown = document.getElementById(this.id);
		this.menuElement = document.getElementById(this.id + '-menu');
		this.activeTaxonomy = '';
	}

	/**
	 *  return an initialization function
	 */
	init(options) {

	}

	/**
	 * @param   String
	 * @chainable
	 */
	setDropdownDataset(activeTaxonomy) {
		this.dropdown.dataset.activeTaxonomy = activeTaxonomy;
		return this;
	}

	/**
	 * @param   String
	 * @chainable
	 */
	setActiveTaxonomy(activeTaxonomy) {
		this.activeTaxonomy = activeTaxonomy;
		return this;
	}

	/**
	 *
	 * @param String
	 * @chainable
	 */
	configure(data) {
		// set active taxonomy data attribute
		this.setDropdownDataset(data.taxonomy)
			.setActiveTaxonomy(data.taxonomy);

		return this;
	}

	toggleDropdown() {

	}

    /**
     * @chainable
     */
	show() {
		$(this.dropdown).addClass(this.name + '--' + this.activeTaxonomy);
		$(this.dropdown).removeClass(this.name + '--inactive');
		$(this.dropdown).addClass(this.name + '--active');
		return this;
	}

	/**
	 * @chainable
	 */
	close() {
		$(this.dropdown).removeClass(this.name + '--' + this.activeTaxonomy);
		$(this.dropdown).removeClass(this.name + '--active');
		$(this.dropdown).addClass(this.name + '--inactive');
		return this;
	}

	/**
	 * @chainable
	 */
	reset() {
		this.setActiveTaxonomy('').setDropdownDataset('');
		return this;
	}

}